import { Stack } from '@mantine/core'
import { useEffect, useState, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getFacility } from 'app/state/ducks/facilities/selectors'
import { useNavigate } from 'react-router-dom'
import cleanUUID from 'app/views/components/functions/cleanUUID'
import { EntityParams } from 'app/models/entity-params'
import { getEntities } from 'app/state/ducks/entities/selectors'
import { getContacts } from 'app/state/ducks/contacts/selectors'
import { getFacilityLendersPositionsWithLoading } from 'app/state/ducks/lenders-positions/selectors'
import { DealParams } from 'app/models/deal-params'
import { getDeal, getDeals } from 'app/state/ducks/deals/selectors'
import { Fees } from 'app/models/fees-params'
import { getFacilityFees } from 'app/state/ducks/fees/selectors'
import { getIndexRateOptions } from 'app/state/ducks/index-rate-options/selectors'
import { DetailSection } from 'app/views/components/detailSections/detail-section'
import { DataBoxLayout } from 'app/views/components/detailSections/data-box-layout'
import { DetailSectionHeader } from 'app/views/components/detailSections/detail-section-header'
import DealRelatedFacilitiesDetails from 'app/views/pages/deals-management/deals/deal-details/deal-related-facilities-details'
import { ContactParams } from 'app/models/contact-params'
import { getCalendars } from 'app/state/ducks/holiday-calendars/selectors'
import { buildFacilityDetailSections } from 'app/views/components/functions/buildDetailsObjects'
import 'app/styles/components/facility-details.css'


export default function FacilityDetailsInfo() {
    const navigate = useNavigate()
    const facility = useSelector(getFacility)
    const currentDeal = useSelector(getDeal)
    const holidayCalendars = useSelector(getCalendars)
    const entityIdToName = new Map<string, string>()
    const entities: EntityParams[] = useSelector(getEntities)
    const contacts: ContactParams[] = useSelector(getContacts)
    const { data, isLoading } = useSelector(
        getFacilityLendersPositionsWithLoading
    )
    let lendersPositions = data
    const deals: DealParams[] = useSelector(getDeals)
    const [deal, setDeal] = useState<DealParams | undefined>()
    const allIndexes = useSelector(getIndexRateOptions)
    const fees: Fees[] = useSelector(getFacilityFees)
    const [facilityFees, setFacilityFees] = useState<Fees[]>(fees);

    const oldAmendmentFee = facility?.amendmentFees

    if (
        facility &&
        facility.amendmentLenders &&
        facility.amendmentLenders.length > 0
    ) {
        lendersPositions = facility.amendmentLenders
    }

    useEffect(() => {
        if (fees.length > 0 && !oldAmendmentFee) {
            setFacilityFees(fees);
        } else if (fees && oldAmendmentFee && oldAmendmentFee.length > 0) {
            setFacilityFees(oldAmendmentFee);
        } else {
            setFacilityFees([])
        }
    }, [fees, oldAmendmentFee, facility])


    useEffect(() => {
        if (!facility || !deals) {
            return
        }
        const deal = deals.find(d => d.id == facility.dealId.id)
        if (deal) {
            setDeal(deal)
        }
    }, [deals, facility])

    useEffect(() => {
        if (!currentDeal) {
            return
        }
        setDeal(currentDeal)
    }, [currentDeal])


    if (Array.isArray(entities)) {
        for (const entity of entities) {
            if (entity.id) {
                entityIdToName.set(cleanUUID(entity.id), entity.entityName)
            }
        }
    }

    const {
        facilityDetailsObjectArray,
        facilityIdentifiersObjectArray,
        facilityFinancialsObjectArray,
        facilityContactsObjectArray,
    } = (facility && deal) ? buildFacilityDetailSections(facility, deal, entityIdToName, entities, contacts, allIndexes, holidayCalendars, facilityFees, isLoading, lendersPositions, navigate) : {
        facilityDetailsObjectArray: [],
        facilityIdentifiersObjectArray: [],
        facilityFinancialsObjectArray: [],
        facilityContactsObjectArray: [],
    }

    const renderDetailSection = (headerText: string, detailObjArr: any[], columnCount: number) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            <DetailSection detailObjArr={detailObjArr} columnCount={columnCount} />
        </>
    );

    const renderTableSection = (headerText: string, tableSection: ReactNode) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            {tableSection}
        </>
    );

    return (
        <Stack w='100%' className='sectionRemoveGap sectionBody'>
            <Stack w='100%' pt='12px' className='sectionDetailBody noHeader'>
                <DataBoxLayout
                    sections={[
                        [renderDetailSection('Details', facilityDetailsObjectArray, 3), renderDetailSection('Identifiers', facilityIdentifiersObjectArray, 3)],
                        [renderDetailSection('Financials', facilityFinancialsObjectArray, 3), renderDetailSection('Contacts', facilityContactsObjectArray, 3)]
                    ]}
                    tableSections={[renderTableSection('Related Facilities', <DealRelatedFacilitiesDetails />)]}
                />
            </Stack>
        </Stack>
    )
}